import React, {Fragment} from 'react'

import {BreadcrumbBox, StyledLinkBox} from './styles'

import HomeIcon from '../../../images/icons/new-dashboard/home-icon.svg'
import ArrowRight from '../../../images/icons/new-dashboard/arrow-right.svg'
import {Link} from 'react-router-dom'
import {BreadcrumbType} from '.'

type Props = {
  breadcrumbs: BreadcrumbType[]
}

const View = ({breadcrumbs}: Props) => {
  return (
    <BreadcrumbBox>
      <Link to={'/'}>
        <img src={HomeIcon} alt="Dashboard" style={{display: 'flex'}} />
      </Link>
      <img src={ArrowRight} alt="Right" style={{marginLeft: '8px'}} />
      {breadcrumbs.map((breadcrumb, key) => {
        return (
          <Fragment key={`br-${key}`}>
            <StyledLinkBox $isGrey={breadcrumbs.length > key + 1}>
              <Link to={breadcrumb.url}>{breadcrumb.title}</Link>
            </StyledLinkBox>
            {breadcrumbs.length > key + 1 && (
              <img src={ArrowRight} alt="Right" />
            )}
          </Fragment>
        )
      })}
    </BreadcrumbBox>
  )
}

export default View
